import { Box, LinearProgress, Typography } from "@mui/material";
import AppLogo from "../AppLogo";
import { readStoredThemeMode } from "../../theme/appTheme";
import { APP_NAME, MALAWI_BRAND } from "../../config/brand";

/**
 * Branded splash / loading screen (PWA cold start & app bootstrap).
 * Hides the static HTML splash once React mounts.
 */
export default function SplashScreen({ message = "Loading your school portal…" }) {
  const isLight = readStoredThemeMode() === "light";
  const { colors } = MALAWI_BRAND;

  return (
    <Box
      className="app-splash-screen"
      sx={{
        position: "fixed",
        inset: 0,
        zIndex: 10000,
        bgcolor: isLight ? "#f5f5f5" : "#0a0a0a",
        color: isLight ? colors.black : "#f5f5f5",
        display: "flex",
        flexDirection: "column",
        alignItems: "center",
        justifyContent: "center",
        paddingTop: "env(safe-area-inset-top)",
        paddingBottom: "env(safe-area-inset-bottom)",
      }}
    >
      <Box
        sx={{
          display: "flex",
          flexDirection: "column",
          alignItems: "center",
          gap: 2,
          px: 3,
          maxWidth: 360,
          textAlign: "center",
          "@keyframes splash-pulse": {
            "0%, 100%": { transform: "scale(1)", opacity: 1 },
            "50%": { transform: "scale(1.04)", opacity: 0.92 },
          },
        }}
      >
        <Box
          sx={{
            display: "flex",
            height: 5,
            width: 72,
            borderRadius: 1,
            overflow: "hidden",
            mb: 0.5,
          }}
          aria-hidden
        >
          <Box sx={{ flex: 1, bgcolor: colors.black }} />
          <Box sx={{ flex: 1, bgcolor: colors.red }} />
          <Box sx={{ flex: 1, bgcolor: colors.green }} />
        </Box>

        <AppLogo
          size={88}
          sx={{
            borderRadius: 3,
            bgcolor: "#fff",
            animation: "splash-pulse 1.8s ease-in-out infinite",
            boxShadow: isLight
              ? "0 12px 40px rgba(15, 45, 92, 0.14)"
              : "0 12px 40px rgba(0,0,0,0.45)",
          }}
        />

        <Typography variant="h5" fontWeight={800} letterSpacing={-0.5}>
          {APP_NAME}
        </Typography>
        <Typography variant="body2" sx={{ opacity: 0.75, lineHeight: 1.5 }}>
          {MALAWI_BRAND.tagline}
        </Typography>
        <Typography variant="caption" color="text.secondary">
          {message}
        </Typography>

        <LinearProgress
          sx={{
            width: "min(220px, 70vw)",
            mt: 1,
            borderRadius: 1,
            bgcolor: isLight ? "rgba(0,0,0,0.08)" : "rgba(255,255,255,0.12)",
            "& .MuiLinearProgress-bar": {
              bgcolor: isLight ? colors.green : colors.sun,
            },
          }}
        />
      </Box>
    </Box>
  );
}
